(function() {    
  var modal = document.getElementById('newsletter-modal');
  if (!modal) return;
  var closeBtns = modal.querySelectorAll('[data-modal-close]');
  var HIDE_DAYS = 7;
  var STORAGE_KEY = 'newsletter_modal_shown';
  var form = modal.querySelector('.newsletter-modal__form');
  var emailInput = modal.querySelector('.newsletter-modal__input');
  var successMessage = modal.querySelector('.newsletter-modal__message--success');
  var errorMessage = modal.querySelector('.newsletter-modal__message--error');

  // Handle form submission - Shopify form will handle the API call
  if (form) {
    // Check if form was successfully submitted (after page load/AJAX)
    if (successMessage && /** @type {HTMLElement} */ (successMessage).offsetParent !== null) {
      // Form was successfully submitted, close modal after delay
      setTimeout(function() {
        if (modal) /** @type {HTMLElement} */ (modal).style.display = 'none';
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      }, 2000);
    }

    // Listen for form submission
    form.addEventListener('submit', function(e) {
      // Let Shopify handle the form submission
      // Shopify's customer form will submit to /contact#contact_form
      // and process the newsletter subscription server-side
      // If form submits via AJAX (some themes), handle success response
      // Otherwise, form will reload page and success message will be shown
    });

    // Watch for success message appearing (for AJAX submissions)
    if (successMessage) {
      var successElement = /** @type {HTMLElement} */ (successMessage);
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          // Check if success message becomes visible
          var isVisible = successElement.offsetParent !== null && 
                         successElement.style.display !== 'none';
          if (isVisible) {
            setTimeout(function() {
              if (modal) /** @type {HTMLElement} */ (modal).style.display = 'none';
              localStorage.setItem(STORAGE_KEY, Date.now().toString());
            }, 2000);
          }
        });
      });
      
      // Observe changes to the success message
      observer.observe(successElement, { 
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['style', 'class']
      });
      
      // Also check periodically for visibility (fallback)
      var checkSuccess = setInterval(function() {
        if (successElement && successElement.offsetParent !== null) {
          clearInterval(checkSuccess);
          setTimeout(function() {
            if (modal) /** @type {HTMLElement} */ (modal).style.display = 'none';
            localStorage.setItem(STORAGE_KEY, Date.now().toString());
          }, 2000);
        }
      }, 100);
      
      // Clear interval after 10 seconds
      setTimeout(function() {
        clearInterval(checkSuccess);
      }, 10000);
    }
  }

  function getLastClosed() {
    var val = localStorage.getItem(STORAGE_KEY);
    if (!val) return null;
    var ts = parseInt(val, 10);
    return isNaN(ts) ? null : ts;
  }

  function shouldShowModal() {
    var lastClosed = getLastClosed();
    if (!lastClosed) return true;
    var now = Date.now();
    var diff = now - lastClosed;
    return diff > HIDE_DAYS * 24 * 60 * 60 * 1000;
  }

  closeBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      if (btn.classList.contains('newsletter-modal__close') || btn.classList.contains('newsletter-modal__overlay')) {
        if (modal) /** @type {HTMLElement} */ (modal).style.display = 'none';
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      }
    });
  });

  function showModal() {
    if (!shouldShowModal()) return;
    if (modal) /** @type {HTMLElement} */ (modal).style.display = 'flex';
    // Focus the email input when modal opens
    if (emailInput) {
      setTimeout(function() {
        /** @type {HTMLElement} */ (emailInput).focus();
      }, 100);
    }
  }

  var scrolledEnough = false;
  window.addEventListener('scroll', function() {
    if (scrolledEnough) return;
    if (window.scrollY > window.innerHeight) {
      scrolledEnough = true;
    }
  });

  setTimeout(function() {
    if (scrolledEnough && shouldShowModal()) {
      showModal();
    } else {
      var checkScroll = function() {
        if (window.scrollY > window.innerHeight) {
          showModal();
          window.removeEventListener('scroll', checkScroll);
        }
      };
      window.addEventListener('scroll', checkScroll);
    }
  }, 10000);
})();
